import { throwError } from "rxjs";
import { ajax as ajax$1 } from "rxjs/ajax";
import { map, catchError } from "rxjs/operators";
import "@opentelemetry/api";
import "../otel/TraceProvider.js";
import { applyLocationAttrs, applyUserAttrs, applyHttpRequestAttrs, applyHttpResponseAttrs } from "../otel/OtelSpan.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
const ajax = (tracingService) => (request, user, parentSpan) => {
  const ajaxRequest = request;
  const url = ajaxRequest?.url;
  const method = ajaxRequest?.method ?? "GET";
  const tracer = tracingService.getTracer();
  const ctx = tracingService.setSpanOnContext(parentSpan);
  return tracer.startActiveSpan(`REST HTTP ${method}`, void 0, ctx, (span) => {
    applyLocationAttrs(span);
    applyUserAttrs(span, user);
    applyHttpRequestAttrs(span, url, method, "xhr");
    return ajax$1(ajaxRequest).pipe(
      map((r) => {
        applyHttpResponseAttrs(span, r.status?.toString());
        tracingService.endSpanOk(span);
        return r;
      }),
      catchError((e) => {
        applyHttpResponseAttrs(span, e.status?.toString(), e.response?.traceId, e.message);
        tracingService.endSpanFailed(span, e.message);
        return throwError(e);
      })
    );
  });
};
export {
  ajax
};
//# sourceMappingURL=ajaxProxy.js.map
